// import { useEffect, useState } from "react";
// import { getMyAttendanceApi } from "../../app/api";

// export default function MyAttendance() {
//   const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imagePreview, setImagePreview] = useState(null);

//   // ✅ Pagination
//   const [page, setPage] = useState(1);
//   const recordsPerPage = 5;

//   // ✅ Monthly Filter
//   const [selectedMonth, setSelectedMonth] = useState(
//     new Date().toISOString().slice(0, 7) // YYYY-MM
//   );

//   // ✅ Fetch Data
//   // useEffect(() => {
//   //   getMyAttendanceApi().then((res) => {
//   //     if (res.success && Array.isArray(res.data)) {
//   //       setRecords(res.data);
//   //     }
//   //     setLoading(false);
//   //   });
//   // }, []);



//   // ✅ Format helpers
//   const formatMinutes = (min) => {
//     if (min === null || min === undefined) return "0m";
//     return `${min}m`;
//   };

//   const formatDate = (date) =>
//     typeof date === "string" ? date.split("T")[0] : "--";

//   // ✅ Monthly Filter Logic
//   const filteredRecords = records.filter((row) => {
//     if (!row.attendance_date) return false;
//     return row.attendance_date.startsWith(selectedMonth);
//   });

//   // ✅ Pagination based on filtered data
//   const totalPages = Math.ceil(records.length / recordsPerPage);

//   const startIndex = (page - 1) * recordsPerPage;

//   const paginatedRecords = records.slice(
//     startIndex,
//     startIndex + recordsPerPage
//   );

//   // ✅ Reset page if needed
//   useEffect(() => {
//     if (page > totalPages) {
//       setPage(1);
//     }
//   }, [filteredRecords]);

//   if (loading) {
//     return (
//       <div className="p-6 text-center text-gray-600">
//         Loading attendance...
//       </div>
//     );
//   }





//   // const loadAttendance = async () => {
//   //   setLoading(true);

//   //   const [year, month] = selectedMonth.split("-"); // "2026-03"

//   //   const res = await getMyAttendanceApi(month, year);

//   //   if (res?.success && Array.isArray(res.data)) {
//   //     setRecords(res.data);
//   //   } else {
//   //     setRecords([]);
//   //   }

//   //   setPage(1); // reset pagination
//   //   setLoading(false);
//   // };

//   const loadAttendance = async () => {
//     setLoading(true);

//     const [year, month] = selectedMonth.split("-");

//     const res = await getMyAttendanceApi(month, year);

//     if (res?.success && Array.isArray(res.data)) {
//       setRecords(res.data);
//     } else {
//       setRecords([]);
//     }

//     setPage(1);
//     setLoading(false);
//   };

//   useEffect(() => {
//     loadAttendance(); // ✅ now it's defined
//   }, [selectedMonth]);

import { useCallback, useEffect, useRef, useState } from "react";
import { getMyAttendanceApi } from "../../app/api";
import { CalendarDays, Target, TrendingUp } from "lucide-react";
import { connectSocket, getSocket } from "../../socket/socket";
import { getTodayDateInputValue } from "../../utils/dateFormat";

export default function MyAttendance() {
  const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
  const DAILY_TARGET_MINUTES = 8 * 60 + 15;

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(null);
  const liveRefreshTimerRef = useRef(null);

  // ✅ Pagination
  const [page, setPage] = useState(1);
  const recordsPerPage = 5;

  // ✅ Monthly Filter
  const [selectedMonth, setSelectedMonth] = useState(
    getTodayDateInputValue().slice(0, 7)
  );

  // ✅ FETCH FUNCTION (define BEFORE useEffect)
  const loadAttendance = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setLoading(true);

    const [year, month] = selectedMonth.split("-");

    const res = await getMyAttendanceApi(month, year);

    if (res?.success && Array.isArray(res.data)) {
      setRecords(res.data);
    } else {
      setRecords([]);
    }

    setPage(1);
    if (!silent) setLoading(false);
  }, [selectedMonth]);

  // ✅ CALL API WHEN MONTH CHANGES
  useEffect(() => {
    loadAttendance();
  }, [loadAttendance]);

  // ✅ Helpers
  const formatMinutes = (min) => {
    if (!min) return "0m";
    return `${min}m`;
  };

  const formatDuration = (minutes) => {
    const safeMinutes = Math.max(0, Math.round(Number(minutes) || 0));
    const hours = Math.floor(safeMinutes / 60);
    const mins = safeMinutes % 60;
    return hours ? `${hours}h ${mins}m` : `${mins}m`;
  };

  const getWorkMinutes = (row) => Number(row?.total_minutes) || 0;

  const isCompletedWorkDay = (row) =>
    getWorkMinutes(row) > 0 && Boolean(row?.punch_out);

  const getDateKey = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      const directDate = date.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
      if (directDate) return directDate;
    }

    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) return "";
    return parsed.toLocaleDateString("en-CA");
  };

  const formatDate = (date) => getDateKey(date) || "--";

  const mergeLiveAttendance = useCallback((attendance) => {
    if (!attendance?.attendance_date && !attendance?.punch_in) return;

    const attendanceDate = getDateKey(attendance.attendance_date) || getTodayDateInputValue();
    if (!attendanceDate.startsWith(selectedMonth)) return;

    setRecords((currentRecords) => {
      const nextRecords = [...currentRecords];
      const rowIndex = nextRecords.findIndex(
        (row) => getDateKey(row.attendance_date) === attendanceDate
      );
      const normalizedAttendance = {
        ...attendance,
        attendance_date: attendance.attendance_date || attendanceDate,
      };

      if (rowIndex >= 0) {
        nextRecords[rowIndex] = {
          ...nextRecords[rowIndex],
          ...normalizedAttendance,
        };
        return nextRecords;
      }

      return [normalizedAttendance, ...nextRecords];
    });
  }, [selectedMonth]);

  useEffect(() => {
    const socket = getSocket() || connectSocket();
    if (!socket) return undefined;

    const refreshMyAttendance = (payload = {}) => {
      window.clearTimeout(liveRefreshTimerRef.current);

      if (payload?.attendance) {
        mergeLiveAttendance(payload.attendance);
      }

      liveRefreshTimerRef.current = window.setTimeout(() => {
        loadAttendance({ silent: true });
      }, payload?.attendance ? 900 : 200);
    };

    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") refreshMyAttendance();
    };

    const liveEvents = [
      "attendance_updated",
      "punched_in",
      "punched_out",
      "break_started",
      "break_ended",
    ];

    liveEvents.forEach((eventName) => socket.on(eventName, refreshMyAttendance));
    window.addEventListener("focus", refreshMyAttendance);
    document.addEventListener("visibilitychange", refreshWhenVisible);

    return () => {
      liveEvents.forEach((eventName) => socket.off(eventName, refreshMyAttendance));
      window.removeEventListener("focus", refreshMyAttendance);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
      window.clearTimeout(liveRefreshTimerRef.current);
    };
  }, [loadAttendance, mergeLiveAttendance]);

  // ✅ FILTER BY MONTH (optional if API already filtered)
  const filteredRecords = records.filter((row) =>
    getDateKey(row.attendance_date).startsWith(selectedMonth)
  );

  const now = new Date();
  const weekStart = new Date(now);
  const day = weekStart.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  weekStart.setDate(weekStart.getDate() + diffToMonday);
  weekStart.setHours(0, 0, 0, 0);

  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  weekEnd.setHours(23, 59, 59, 999);

  const completedMonthRecords = filteredRecords.filter(isCompletedWorkDay);
  const completedWeekRecords = completedMonthRecords.filter((row) => {
    const dateKey = getDateKey(row.attendance_date);
    if (!dateKey) return false;
    const rowDate = new Date(`${dateKey}T00:00:00`);
    return rowDate >= weekStart && rowDate <= weekEnd;
  });

  const getAverageMinutes = (items) => {
    if (!items.length) return 0;
    return items.reduce((sum, row) => sum + getWorkMinutes(row), 0) / items.length;
  };

  const weeklyAverage = getAverageMinutes(completedWeekRecords);
  const monthlyAverage = getAverageMinutes(completedMonthRecords);
  const weeklyGap = weeklyAverage - DAILY_TARGET_MINUTES;
  const monthlyGap = monthlyAverage - DAILY_TARGET_MINUTES;

  // ✅ PAGINATION (use filteredRecords, NOT records)
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  const startIndex = (page - 1) * recordsPerPage;

  const paginatedRecords = filteredRecords.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  // ✅ RESET PAGE IF DATA CHANGES
  useEffect(() => {
    if (page > totalPages) setPage(1);
  }, [filteredRecords]);

  if (loading) {
    return <div className="p-6 text-center text-gray-600">Loading attendance...</div>;
  }
  return (
    <>
      <div className="rounded-2xl p-3 md:p-5 bg-[#12082F] text-white shadow-2xl md:mt-20">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-3">
          <h2 className="font-semibold text-base md:text-xl">
            My Attendance
          </h2>

          {/* ✅ MONTH FILTER */}
          <div className="flex gap-2 items-center">
            <input
              type="month"
              value={selectedMonth}
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                setPage(1);
              }}
              className="px-3 py-1 rounded-lg bg-white/100 text-black border border-white/20 cursor-pointer"
            />

            <button
              onClick={() => {
                setSelectedMonth(getTodayDateInputValue().slice(0, 7));
                setPage(1);
              }}
              className="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20"
            >
              Reset
            </button>
          </div>
        </div>

        <div className="mb-5 grid grid-cols-1 gap-3 md:grid-cols-3">
          <AverageTimeCard
            title="This Week Avg"
            value={formatDuration(weeklyAverage)}
            minutes={weeklyAverage}
            subtitle={`${completedWeekRecords.length} completed day${completedWeekRecords.length === 1 ? "" : "s"}`}
            gapMinutes={weeklyGap}
            icon={TrendingUp}
          />
          <AverageTimeCard
            title="This Month Avg"
            value={formatDuration(monthlyAverage)}
            minutes={monthlyAverage}
            subtitle={`${completedMonthRecords.length} completed day${completedMonthRecords.length === 1 ? "" : "s"}`}
            gapMinutes={monthlyGap}
            icon={CalendarDays}
          />
          <div className="relative overflow-hidden rounded-3xl border border-cyan-200/15 bg-gradient-to-br from-cyan-300/15 via-white/[0.07] to-violet-500/14 p-4 shadow-[0_20px_55px_rgba(4,2,22,0.28)]">
            <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-cyan-300/15 blur-2xl" />
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-[11px] font-black uppercase tracking-[0.24em] text-cyan-100/70">
                  Daily Target
                </p>
                <p className="mt-2 text-3xl font-black text-white">
                  {formatDuration(DAILY_TARGET_MINUTES)}
                </p>
                <p className="mt-1 text-sm font-semibold text-white/58">
                  Required working time per day
                </p>
              </div>
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-cyan-300/14 text-cyan-100 ring-1 ring-cyan-100/18">
                <Target className="h-6 w-6" />
              </span>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="overflow-x-auto rounded-2xl bg-white/5 backdrop-blur">
          <table className="min-w-[1000px] w-full text-sm text-white">
            <thead>
              <tr className="text-left text-gray-300 border-b border-white/10">
                <th className="p-3">Employee</th>
                <th className="p-3">Date</th>
                <th className="p-3">Punch In</th>
                <th className="p-3">Img In</th>
                <th className="p-3">Img Out</th>
                <th className="p-3">Punch Out</th>
                <th className="p-3">Total Hours</th>
                <th className="p-3">Break</th>
                <th className="p-3">Status</th>
                <th className="p-3">Early / Extra</th>
              </tr>
            </thead>

            <tbody>
              {paginatedRecords.length > 0 ? (
                paginatedRecords.map((row, i) => (
                  <tr
                    key={i}
                    className="border-b border-white/5 hover:bg-white/10 transition"
                  >
                    <td className="p-3 font-medium">
                      {row.name || [row.first_name, row.last_name].filter(Boolean).join(" ") || "—"}
                      {row.emp_id ? (
                        <span className="block text-xs text-white/50">{row.emp_id}</span>
                      ) : null}
                    </td>

                    <td className="p-3">
                      {formatDate(row.attendance_date)}
                    </td>

                    <td className="p-3">{row.punch_in || "—"}</td>

                    <td className="p-3 text-center">
                      {row.punch_in_img ? (
                        <img
                          src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
                          className="w-10 h-10 object-cover rounded cursor-pointer border"
                          alt="Punch in"
                          onClick={() =>
                            setImagePreview(
                              `${IMAGE_BASE_URL}/${row.punch_in_img}`
                            )
                          }
                        />
                      ) : (
                        "—"
                      )}
                    </td>

                    <td className="p-3 text-center">
                      {row.punch_out_img ? (
                        <img
                          src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
                          className="w-10 h-10 object-cover rounded cursor-pointer border"
                          alt="Punch out"
                          onClick={() =>
                            setImagePreview(
                              `${IMAGE_BASE_URL}/${row.punch_out_img}`
                            )
                          }
                        />
                      ) : (
                        "—"
                      )}
                    </td>

                    <td className="p-3">{row.punch_out || "—"}</td>

                    <td className="p-3">
                      {row.total_minutes
                        ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60
                        }m`
                        : "—"}
                    </td>

                    <td className="p-3">
                      {formatMinutes(row.break_minutes)}
                    </td>

                    <td className="p-3">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${row.status === 1
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                          }`}
                      >
                        {row.status === 1 ? "Present" : "Absent"}
                      </span>
                    </td>

                    <td className="p-3 text-xs text-gray-200">
                      Early: {row.early_time || "0m"} <br />
                      Extra: {row.extra_time || "0m"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="p-4 text-center text-gray-400">
                    No Attendance Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className="flex justify-between mt-4 text-sm">
          <div className="opacity-70">
            Page {page} of {totalPages || 1}
          </div>

          <div className="flex gap-2">
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              className="px-3 py-1 rounded bg-white/10 disabled:opacity-40"
            >
              Prev
            </button>

            <button
              disabled={page === totalPages}
              onClick={() => setPage((p) => p + 1)}
              className="px-3 py-1 rounded bg-purple-600 disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* IMAGE MODAL */}
      {imagePreview && (
        <div
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
          onClick={() => setImagePreview(null)}
        >
          <div
            className="bg-white p-4 rounded-xl max-w-[90%] max-h-[90%]"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={imagePreview}
              className="max-w-full max-h-[80vh] rounded"
              alt="Attendance preview"
            />
          </div>
        </div>
      )}
    </>
  );
}

function AverageTimeCard({ title, value, minutes, subtitle, gapMinutes, icon: Icon }) {
  const isOnTrack = gapMinutes >= 0;
  const gapLabel = isOnTrack
    ? `${formatCardDuration(gapMinutes)} ahead`
    : `${formatCardDuration(Math.abs(gapMinutes))} short`;

  return (
    <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06] p-4 shadow-[0_20px_55px_rgba(4,2,22,0.24)]">
      <div className={`absolute -right-10 -top-12 h-28 w-28 rounded-full blur-2xl ${isOnTrack ? "bg-emerald-300/16" : "bg-rose-400/16"}`} />
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[11px] font-black uppercase tracking-[0.24em] text-white/52">
            {title}
          </p>
          <p className="mt-2 text-3xl font-black text-white">
            {value}
          </p>
          <p className="mt-1 text-sm font-semibold text-white/52">
            {subtitle}
          </p>
        </div>
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white/[0.08] text-cyan-100 ring-1 ring-white/10">
          <Icon className="h-6 w-6" />
        </span>
      </div>
      <div className="mt-4 flex items-center gap-2">
        <div className="h-2 flex-1 overflow-hidden rounded-full bg-white/10">
          <div
            className={`h-full rounded-full ${isOnTrack ? "bg-gradient-to-r from-emerald-300 to-cyan-300" : "bg-gradient-to-r from-rose-300 to-amber-200"}`}
            style={{ width: `${Math.min(100, Math.max(8, ((Number(minutes) || 0) / 495) * 100))}%` }}
          />
        </div>
        <span className={`rounded-full px-2.5 py-1 text-[11px] font-black ${isOnTrack ? "bg-emerald-300/14 text-emerald-100" : "bg-rose-300/14 text-rose-100"}`}>
          {gapLabel}
        </span>
      </div>
    </div>
  );
}

function formatCardDuration(minutes) {
  const safeMinutes = Math.max(0, Math.round(Number(minutes) || 0));
  const hours = Math.floor(safeMinutes / 60);
  const mins = safeMinutes % 60;
  return hours ? `${hours}h ${mins}m` : `${mins}m`;
}
// import { useEffect, useState } from "react";
// import { getMyAttendanceApi } from "../../app/api";

// export default function MyAttendance() {
//   const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imagePreview, setImagePreview] = useState(null);

//   const formatMinutes = (min) => {
//     if (min === null || min === undefined) return "0m";
//     return `${min}m`;
//   };

//   const formatDate = (date) =>
//     typeof date === "string" ? date.split("T")[0] : "--";

//   useEffect(() => {
//     getMyAttendanceApi().then((res) => {
//       if (res.success && Array.isArray(res.data)) {
//         setRecords(res.data);
//       }
//       setLoading(false);
//     });
//   }, []);

//   if (loading)
//     return (
//       <div className="text-white/70 text-center py-10">
//         Loading attendance...
//       </div>
//     );

//   return (
//     <>
//       <div className="rounded-2xl mt-5 md:mt-20 p-5 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] text-white border border-white/10 shadow-2xl relative">
//         <h3 className="font-bold text-2xl mb-4">
//           My Attendance
//         </h3>

//         {/* ================= DESKTOP TABLE ================= */}
//         <div className="hidden md:block max-h-[420px] overflow-y-auto">
//           <table className="w-full text-sm border-separate border-spacing-x-3">
//             <thead className="text-white/70">
//               <tr className="border-b border-white/10">
//                 <th className="px-3">Date</th>
//                 <th className="px-3">In</th>
//                 <th className="px-3">Img In</th>
//                 <th className="px-3">Img Out</th>
//                 <th className="px-3">Out</th>
//                 <th className="px-3">Total</th>
//                 <th className="px-3">Break</th>
//                 <th className="px-3">Status</th>
//                 <th className="px-3">Early / Extra</th>
//               </tr>
//             </thead>

//             <tbody>
//               {records.map((row, i) => (
//                 <tr key={i} className="border-b border-white/5 hover:bg-white/5">
//                   <td className="px-3 py-2">
//                     {formatDate(row.attendance_date)}
//                   </td>
//                   <td className="px-3">{row.punch_in || "—"}</td>
//                   <td className="px-3">
//                     {row.punch_in_img ? (
//                       <img
//                         src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
//                         className="w-9 h-9 rounded mx-auto cursor-pointer"
//                         onClick={() =>
//                           setImagePreview(
//                             `${IMAGE_BASE_URL}/${row.punch_in_img}`
//                           )
//                         }
//                       />
//                     ) : "—"}
//                   </td>
//                   <td className="px-3">
//                     {row.punch_out_img ? (
//                       <img
//                         src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
//                         className="w-9 h-9 rounded mx-auto cursor-pointer"
//                         onClick={() =>
//                           setImagePreview(
//                             `${IMAGE_BASE_URL}/${row.punch_out_img}`
//                           )
//                         }
//                       />
//                     ) : "—"}
//                   </td>
//                   <td className="px-3">{row.punch_out || "—"}</td>
//                   <td className="px-3">
//                     {row.total_minutes
//                       ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
//                       : "—"}
//                   </td>
//                   <td className="px-3">
//                     {formatMinutes(row.break_minutes)}
//                   </td>
//                   <td className="px-3">
//                     <span className="px-3 py-1 rounded-full text-xs bg-green-500/20 text-green-300">
//                       {row.status === 1 ? "Present" : "Absent"}
//                     </span>
//                   </td>
//                   <td className="px-3 text-xs">
//                     E: {row.early_time || "0m"} <br />
//                     X: {row.extra_time || "0m"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* ================= MOBILE CARDS ================= */}
//         <div className="md:hidden space-y-3">
//           {records.map((row, i) => (
//             <div
//               key={i}
//               className="bg-gradient-to-br from-[#2d1c6a] to-[#12082f] border border-white/10 rounded-2xl p-4 shadow-lg"
//             >
//               <div className="flex justify-between mb-2">
//                 <p className="font-semibold text-blue-300">
//                   {formatDate(row.attendance_date)}
//                 </p>
//                 <span className={`px-3 py-1 rounded-full text-xs ${
//                   row.status === 1
//                     ? "bg-green-500/20 text-green-300"
//                     : "bg-red-500/20 text-red-300"
//                 }`}>
//                   {row.status === 1 ? "Present" : "Absent"}
//                 </span>
//               </div>

//               <div className="grid grid-cols-2 gap-3 text-sm">
//                 <div>
//                   <p className="text-white/60 text-xs">In</p>
//                   <p>{row.punch_in || "—"}</p>
//                 </div>
//                 <div>
//                   <p className="text-white/60 text-xs">Out</p>
//                   <p>{row.punch_out || "—"}</p>
//                 </div>
//                 <div>
//                   <p className="text-white/60 text-xs">Total</p>
//                   <p className="text-blue-300 font-semibold">
//                     {row.total_minutes
//                       ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
//                       : "—"}
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-white/60 text-xs">Break</p>
//                   <p>{formatMinutes(row.break_minutes)}</p>
//                 </div>
//                 <div>
//                   <p className="text-white/60 text-xs">Early</p>
//                   <p>{row.early_time || "0m"}</p>
//                 </div>
//                 <div>
//                   <p className="text-white/60 text-xs">Extra</p>
//                   <p>{row.extra_time || "0m"}</p>
//                 </div>
//               </div>

//               {(row.punch_in_img || row.punch_out_img) && (
//                 <div className="flex gap-3 mt-4">
//                   {row.punch_in_img && (
//                     <img
//                       src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
//                       className="w-12 h-12 rounded-lg border border-white/20 object-cover cursor-pointer"
//                       onClick={() =>
//                         setImagePreview(
//                           `${IMAGE_BASE_URL}/${row.punch_in_img}`
//                         )
//                       }
//                     />
//                   )}
//                   {row.punch_out_img && (
//                     <img
//                       src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
//                       className="w-12 h-12 rounded-lg border border-white/20 object-cover cursor-pointer"
//                       onClick={() =>
//                         setImagePreview(
//                           `${IMAGE_BASE_URL}/${row.punch_out_img}`
//                         )
//                       }
//                     />
//                   )}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* IMAGE MODAL */}
//       {imagePreview && (
//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() => setImagePreview(null)}
//         >
//           <img
//             src={imagePreview}
//             className="max-h-[80vh] rounded-xl"
//           />
//         </div>
//       )}
//     </>
//   );
// }
